"use strict";

import angular from "angular";

import template from "./reports-nav.component.html";
import "./reports-nav.component.scss";

const name = "reportsNav";
const def = {
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
